import { forwardRef, memo } from "react"
import { Marker as MapLibreMarker } from "maplibre-gl"
import Marker, { MarkerProps } from "@/components/maps/mapLibre/Marker"

export type DriverLocationMarkerProps = Omit<MarkerProps, "children"> & {
  /** Driver initials to display in the center */
  initials?: string
}

const DriverLocationMarker = memo(
  forwardRef<MapLibreMarker, DriverLocationMarkerProps>(
    ({ initials, ...props }, ref) => {
      return (
        <Marker ref={ref} {...props}>
          <div className="relative flex items-center justify-center">
            {/* Pulsing ring animation - matches DriverIcon.ts colors */}
            <div
              className="absolute h-10 w-10 animate-ping rounded-full"
              style={{ backgroundColor: "rgba(182, 214, 255, 0.4)" }}
            />
            <div
              className="absolute h-8 w-8 animate-pulse rounded-full"
              style={{
                backgroundColor: "rgba(182, 214, 255, 0.3)",
                animationDelay: "0.5s",
              }}
            />

            {/* Main circle - #B6D6FF from DriverIcon.ts */}
            <div
              className="relative flex h-6 w-6 items-center justify-center rounded-full"
              style={{ backgroundColor: "#B6D6FF" }}
            >
              {initials ? (
                <span
                  className="font-sans text-black"
                  style={{ fontSize: "10px" }}
                >
                  {initials}
                </span>
              ) : (
                /* Truck icon when no initials */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-3 w-3"
                >
                  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                  <path d="M15 18H9" />
                  <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                  <circle cx="17" cy="18" r="2" />
                  <circle cx="7" cy="18" r="2" />
                </svg>
              )}
            </div>
          </div>
        </Marker>
      )
    },
  ),
)

export default DriverLocationMarker
